import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { IProduct } from '../../../Types/product';
import { List, Typography } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ProductListItem from './ProductListItem';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  products: {
    maxWidth: 600,
    maxHeight: '40vh',
    overflowY: 'auto',
  },
  numProducts: {
    display: 'flex',
  },
  numProductsBold: {
    marginLeft: '0.25rem',
  },
  paginatior: {
    marginTop: theme.spacing(1),
    justifyContent: 'center',
    flexWrap: 'nowrap',
    '& .Mui-selected': {
      background: '#FFFFFF',
      border: '2px solid #09B4D6',
      boxSizing: 'border-box',
      borderRadius: '8px',
    },
  },
}));

const ITEMS_PER_PAGE = 2;

export default function ProductList({
  options,
  selectedOption,
  onSelect,
}: {
  options: Array<IProduct>;
  selectedOption?: IProduct;
  onSelect: (id: string) => void;
}) {
  const classes = useStyles();
  const containerRef = useRef(null);
  const [page, setPage] = React.useState(1);
  const [numOfPages] = React.useState(
    Math.ceil(options.length / ITEMS_PER_PAGE),
  );

  const shouldDisplayPagination = options.length > ITEMS_PER_PAGE;

  const handleChange = (event, value) => {
    setPage(value);
    if (containerRef?.current) {
      containerRef.current.scrollTop = 0;
    }
  };

  useEffect(() => {
    if (options && selectedOption) {
      let selectedProductIndex = options.findIndex(
        (item) => item.id === selectedOption?.id,
      );
      const currentPage = Math.floor(selectedProductIndex / ITEMS_PER_PAGE);
      setPage(currentPage + 1);
    }
  }, [options, selectedOption]);

  useLayoutEffect(() => {
    let selectedProductIndex = options.findIndex(
      (item) => item.id === selectedOption?.id,
    );
    if (containerRef?.current) {
      const rowHeight =
        containerRef.current.getBoundingClientRect().height / ITEMS_PER_PAGE;
      containerRef.current.scrollTop = rowHeight * selectedProductIndex;
    }
  }, [options, selectedOption]);

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.numProducts}>
        Products found:
        <b className={classes.numProductsBold}>{options.length}</b>
      </Typography>
      <List dense className={classes.products} ref={containerRef}>
        {options && (
          <>
            {options
              ?.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE)
              ?.map((product, i) => {
                return (
                  <ProductListItem
                    product={product}
                    isSelected={product.id === selectedOption?.id}
                    onSelect={onSelect}
                    key={product.id}
                  />
                );
              })}
          </>
        )}
      </List>
      {shouldDisplayPagination && (
        <Pagination
          count={numOfPages}
          onChange={handleChange}
          page={page}
          defaultPage={1}
          classes={{ ul: classes.paginatior }}
          shape="rounded"
        />
      )}
    </div>
  );
}
